// extracted by mini-css-extract-plugin
module.exports = {"filterContainer":"styles_filterContainer__jzg51","optimizedWithBatchLabel":"styles_optimizedWithBatchLabel__RREdf"};